import {
  createFrontendPlugin,
  PageBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import AssessmentIcon from '@material-ui/icons/Assessment';

import './SurveyInsights.css';
import {
  focusAreasRouteRef,
  heatmapRouteRef,
  overviewRouteRef,
  questionsRouteRef,
  responseRatesRouteRef,
  rootRouteRef,
} from './routes';

const surveyInsightsIcon = <AssessmentIcon fontSize="inherit" />;

const surveyInsightsPage = PageBlueprint.make({
  params: {
    path: '/survey-insights',
    title: 'Survey Insights',
    icon: surveyInsightsIcon,
    routeRef: rootRouteRef,
  },
});

const surveyInsightsOverviewPage = SubPageBlueprint.make({
  name: 'overview',
  params: {
    path: 'overview',
    title: 'Overview',
    routeRef: overviewRouteRef,
    loader: () => import('./pages/Overview').then(m => <m.Overview />),
  },
});

const surveyInsightsQuestionsPage = SubPageBlueprint.make({
  name: 'questions',
  params: {
    path: 'questions',
    title: 'Questions',
    routeRef: questionsRouteRef,
    loader: () => import('./pages/Questions').then(m => <m.Questions />),
  },
});

const surveyInsightsHeatmapPage = SubPageBlueprint.make({
  name: 'heatmap',
  params: {
    path: 'heatmap',
    title: 'Heatmap',
    routeRef: heatmapRouteRef,
    loader: () => import('./pages/Heatmap').then(m => <m.Heatmap />),
  },
});

const surveyInsightsFocusAreasPage = SubPageBlueprint.make({
  name: 'focus-areas',
  params: {
    path: 'focus-areas',
    title: 'Focus Areas',
    routeRef: focusAreasRouteRef,
    loader: () => import('./pages/FocusAreas').then(m => <m.FocusAreas />),
  },
});

const surveyInsightsResponseRatesPage = SubPageBlueprint.make({
  name: 'response-rates',
  params: {
    path: 'response-rates',
    title: 'Response Rates',
    routeRef: responseRatesRouteRef,
    loader: () =>
      import('./pages/ResponseRates').then(m => <m.ResponseRates />),
  },
});

const surveyInsightsPlugin = createFrontendPlugin({
  pluginId: 'survey-insights',
  title: 'Survey Insights',
  icon: surveyInsightsIcon,
  routes: {
    root: rootRouteRef,
  },
  extensions: [
    surveyInsightsPage,
    surveyInsightsOverviewPage,
    surveyInsightsQuestionsPage,
    surveyInsightsHeatmapPage,
    surveyInsightsFocusAreasPage,
    surveyInsightsResponseRatesPage,
  ],
});

export default surveyInsightsPlugin;
